
import { useState,useEffect,useRef } from 'react';
import { useParams,useNavigate,useLocation } from 'react-router-dom';
import { Table,Input,message,Button,Empty,Space, InputNumber,Modal,TimePicker,AutoComplete,Tooltip } from 'antd';
import { LeftOutlined,ExclamationCircleOutlined,DownOutlined,QuestionCircleOutlined } from '@ant-design/icons';
import type { TableProps } from 'antd';
import { DataType } from './column';
import { activityProductList,saveActivityProduct,productStockInfo } from '@/services/activity';
import { ResDataType } from '@/services/ajax';
import styles from './index.module.scss'
import usePagAndCommon from '@/hooks/usePagAndCommon';
import { produce } from 'immer'
import { productDataType } from '@/components/selectProduct/column'
import ProductList from "@/components/selectProduct"
import { useSelector } from 'react-redux';
import { debounce } from "@/utils"
import dayjs from 'dayjs';
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';
import usePermission from "@/hooks/usePermission";
import { RootType } from '@/store';
import { TooltipTextList } from '@/constant';

export default function ActivityProduct() {
    const { id = 0 } = useParams();
    const { menuId } = useGetCurMenuId();
    const location = useLocation();
    const status = location.state?.status;
    const [modal, contextHolder] = Modal.useModal();
    const { merchantId } = useSelector((state:RootType)=>state.user);
    const nav = useNavigate();
    const { flag,setFlag } = usePagAndCommon();
    const [showMore,setShowMore] = useState(false);
    const [productName, setProductName] = useState<string>('');
    const [allData,setAllData] = useState<DataType[]>([]);
    const [data,setData] = useState<DataType[]>([]);
    const selectProduct = useRef<any>(null);
    const defaultData = {
        id: "0",
        activityId: id,
        inventory: 0,
        orderNum: 0,
        collectTimeLimit: '00:00:00',
        collectTimeValidity: 0,
        delayCollectionTime: 0,
    }
    const { hasMenuPermission } = usePermission();
    const isEdit = hasMenuPermission(menuId, 'edit');
    const tableBody = document.querySelector('.ant-table-body');
    const handleScroll = (e: any) => {
        const scrollDre = e.deltaY;
        if (scrollDre > 50) {
          setShowMore(false);
        }
    };
  const fetchData = async () => {
      setFlag(true)
      const res = await activityProductList(id as number) as ResDataType;
      if (res.code != 0) {
        message.error(res.message);
      } else {
        setAllData(res.data.list);
        setData(res.data.list);
        res.data.list.length > 8 && setShowMore(true);
      }
      setFlag(false)
  }

  const handleSearch = () => {
   setData(allData.filter(item => item.productName.includes(productName))); 
  }
  const isValid = () => data.every(item => 
    (item.privilegePrice || item.privilegePrice == 0) &&
    (item.inventory || item.inventory == 0 ) &&
    item.collectTimeLimit &&
    (item.collectTimeValidity || item.collectTimeValidity == 0 ) &&
    (item.delayCollectionTime || item.delayCollectionTime == 0)
  );
  useEffect(()=> {
    fetchData();
    document.querySelector('.ant-table-body')?.addEventListener('wheel', handleScroll);
    return () => {
      document.querySelector('.ant-table-body')?.removeEventListener('wheel', handleScroll);
    };
  },[])

  useEffect(()=> {
    handleSearch();
  },[productName])

  const handleSelect = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select(); 
 }

  const addProduct = (productList:any) => {
    const addProduct = productList.map((item:productDataType)=> {
      return {
        ...defaultData,
        privilegePrice:item.costPrice,
        productId: item.productId,
        productName: item.productName,
      }
    })
    setData(produce((draft)=>{
        addProduct.reduce((acc:any, cur:DataType) => {
            if (!acc.some((item:DataType) => item.productId == cur.productId)) {
                acc.push({
                    ...cur,
                    orderNum: String(acc.length+1),
                }); 
            }
            return acc;
        }, draft); 
    }))
    setAllData(produce((draft)=>{
      addProduct.reduce((acc:any, cur:DataType) => {
          if (!acc.some((item:DataType) => item.productId == cur.productId)) {
              acc.push({
                  ...cur,
                  orderNum: String(acc.length+1),
              }); 
          }
          return acc;
      }, draft); 
  }))
    setShowMore(false);
    setTimeout(()=> {
      if (tableBody) {
        tableBody.scrollTo({
          top: tableBody.scrollHeight,
          behavior: 'smooth'
        });
      } 
    },0)
  }

  const handleSave = async () => {
    const productList = data.map((item:DataType,index)=> {
      return {
        ...item,
        orderNum: index+1,
        collectTimeLimit: dayjs(item.collectTimeLimit,"HH:mm:ss").format('HH:mm:ss'),
      }
    })
    const res = await saveActivityProduct({activityId:id as number,productList}) as ResDataType;
    if (res.code!= 0) {
      message.error(res.message);    
      return;
    }
    message.success('保存成功');
    nav(-1);
  }

  const getProductStock = async (value:number,productId:number) => {
      const res = await productStockInfo(id,productId) as ResDataType;
      if (res.code == 0) {
        const isTips = ( (value*res.data.cycleTotal) + res.data.useStock ) > res.data.stock;
        if (isTips) {
         message.warning(`当前输入库存超出该权益剩余可用库存,请谨慎输入`); 
        }
      }
  }

  const debouncedQuery = debounce((value:number,productId:number) => {
    value && getProductStock(value,productId)
  });

  const handleQuery = (value:number,productId:number) => {
    debouncedQuery(value,productId);
  };

  const toolTipContent = (title:string,tipText:string)=>{
    return (
        <div>
            {title}
            <Tooltip title={tipText} >
                <span style={{ marginLeft:'5px' }}><QuestionCircleOutlined /></span>
            </Tooltip>
        </div>
        
    )
  }

  const column: TableProps<DataType>['columns'] = [
    {
      title: '排序',
      dataIndex: 'orderNum',
      key: 'orderNum',
      width: 80,
    },
    {
      title: '权益名称',
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: '权益价',
      dataIndex: 'privilegePrice',
      key: 'privilegePrice',
      render: (_, record,index) => (
        <InputNumber disabled={(status==0 && record.id != 0)} onFocus={handleSelect} className={styles.input} value={record.privilegePrice} min={0} onChange={(e)=>{ setData(produce((draft)=>{
            draft[index].privilegePrice = e as number;
          })) 
          setAllData(produce((draft)=>{
            const index = draft.findIndex(item=> item.productId == record.productId);
            draft[index].privilegePrice = e as number;
          }))
        }} />
      )
    },
    {
      title: '库存',
      dataIndex: 'inventory',
      key: 'inventory',
      render: (_, record,index) => (
        <InputNumber disabled={!isEdit} onFocus={handleSelect} className={styles.input} value={record.inventory} min={0} onChange={(e)=>{ 
          handleQuery(e as number,record.productId);
          setData(produce((draft)=>{
            draft[index].inventory = e as number;
          }))  
          setAllData(produce((draft)=>{
            const index = draft.findIndex(item=> item.productId == record.productId);
            draft[index].inventory = e as number;
          }))
      }} />
      )
    },
    {
      title: ()=>{ 
        return toolTipContent('可领取时间',TooltipTextList.collectTimeLimit)
      },
      dataIndex: 'collectTimeLimit',
      key: 'collectTimeLimit',
      render: (_, record,index) => (
        <TimePicker disabled={!isEdit} allowClear={false} placeholder="选择领取时间" className={styles.input} value={dayjs(record.collectTimeLimit,"HH:mm:ss")} onChange={(e)=>{ 
          setData(produce((draft)=>{
            draft[index].collectTimeLimit = dayjs(e).format('HH:mm:ss');
          })) 
          setAllData(produce((draft)=>{
            const index = draft.findIndex(item=> item.productId == record.productId);
            draft[index].collectTimeLimit = dayjs(e).format('HH:mm:ss');
          }))
       }} minuteStep={10} secondStep={10} hourStep={1} />
        // <InputNumber  />
      )
    },
    {
      title: ()=>{ 
        return toolTipContent('延长时长（分钟）',TooltipTextList.collectTimeValidity)
      },
      dataIndex: 'collectTimeValidity',
      key: 'collectTimeValidity',
      render: (_, record,index) => (

        <AutoComplete allowClear  disabled={!isEdit}
          options={[
            {value: 10},
            {value: 15},
            {value: 30},
            {value: 45},
            {value: 60},
          ]}
          filterOption={(inputValue, option) =>
            String(option!.value).indexOf(String(inputValue)) !== -1
          }
          onFocus={handleSelect}
          onBlur={(e: any)=>{
            if (!e.target.value) {
              setData(produce((draft)=>{
                draft[index].collectTimeValidity = 0; 
                e.target.value = 0
              }))
              setAllData(produce((draft)=>{
                const index = draft.findIndex(item=> item.productId == record.productId);
                draft[index].collectTimeValidity = 0; 
                  e.target.value = 0
              }))
            }
          }}
          style={{ width: 200 }} value={record.collectTimeValidity} onChange={(e)=>{ 
            const reg = /^\d*(\d*)?$/;
            if (reg.test(e as any)) {
              setData(produce((draft)=>{
                draft[index].collectTimeValidity = e as number;
              }))
              setAllData(produce((draft)=>{
                const index = draft.findIndex(item=> item.productId == record.productId);
                draft[index].collectTimeValidity = e as number;
              }))
            }
              }}
        />
      )
    },
    {
      title: ()=>{ 
        return toolTipContent('延迟领取（小时）',TooltipTextList.delayCollectionTime)
      },
      dataIndex: 'delayCollectionTime',
      key: 'delayCollectionTime',
      render: (_, record,index) => (

        <AutoComplete allowClear  disabled={!isEdit}
          options={[
            {value: 1},
            {value: 2},
            {value: 3},
            {value: 4},
          ]}
          onFocus={handleSelect}
          filterOption={(inputValue, option) =>
            String(option!.value).indexOf(String(inputValue)) !== -1
          }
          onBlur={(e: any)=>{
            if (!e.target.value) {
              setData(produce((draft)=>{
                draft[index].delayCollectionTime = 0; 
                e.target.value = 0
              }))
              setAllData(produce((draft)=>{
                const index = draft.findIndex(item=> item.productId == record.productId);
                draft[index].delayCollectionTime = 0; 
                e.target.value = 0
              }))
            }
          }}
          style={{ width: 200 }} value={record.delayCollectionTime} onChange={(e)=>{
            const reg = /^\d*(\d*)?$/;
            if (reg.test(e as any)) {
              setData(produce((draft)=>{
                draft[index].delayCollectionTime = e as number;
              }))
              setAllData(produce((draft)=>{
                const index = draft.findIndex(item=> item.productId == record.productId);
                draft[index].delayCollectionTime = e as number;
              }))
            }
          }}
        />
      )
    }
  ];

  const confirm = () => {
    modal.confirm({
        title: '提示',
        icon: <ExclamationCircleOutlined />,
        content: '确认保存当前权益吗?',
        okText: '确认',
        cancelText: '取消',
        onOk: handleSave
    });
  };
  return (
    <>
      <div className="headerTitle">
        <div style={{ display:'flex' }}>
            <div className={styles.return} onClick={()=>{ nav(-1) }}>
                 <LeftOutlined />
            </div>
          <h2>权益包权益配置</h2>
        </div>
      </div>

      <div className="card">
        <div className="searchCond" style={{ width:'100%',display:'flex',justifyContent:'space-between' }}>
          <Space size='middle'><Input allowClear placeholder="权益名称" value={productName} size='large' onChange={(e) => setProductName(e.target.value)}/>
            {/* <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button> */}
           </Space>
           <MenuPermissionControl menuId={menuId} operation="edit" >
            <Space size='middle'>
              <Button type="primary" onClick={()=>{ selectProduct.current.open() }}>添加权益</Button>
              <Button type='primary' disabled={!isValid()} onClick={()=>{ 
                  confirm();
              }}>保存</Button>
            </Space>
           </MenuPermissionControl>
        </div>

        <div className="overflow-x-auto" style={{ position:'relative',paddingBottom:'25px' }}>
          <Table<DataType> rowKey='productId'
          columns={[
            ...column,
            {
              title: '操作',
              key: 'action',
              fixed: 'right',
              render: (_, record,index) => (
                <Space size="middle">
                  <MenuPermissionControl menuId={menuId} operation="edit" >
                    <Button danger disabled={status==0 && record.id != 0} onClick={()=>{
                      setData(produce((draft)=>{
                        draft.splice(index,1); 
                      }))
                      setAllData(produce((draft)=>{
                        const index = draft.findIndex(item=> item.productId == record.productId);
                        draft.splice(index,1);
                      }))
                    }}>删除</Button>
                  </MenuPermissionControl>
                </Space>
              ),
            }
          ]} 
          dataSource={data}
          loading={flag}
          pagination={false}
          scroll={{ x: 'max-content', y: 620 }}
          locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
          />
          {
            (data.length > 10 && showMore) && <div onClick={()=> 
              {
                setShowMore(false)
                if (tableBody) {
                  tableBody.scrollTo({
                    top: 520,
                    behavior: 'smooth'
                  });
                } 
              }
            } className={styles.more}>
              <div>点击/滚动查看更多</div>
              <DownOutlined />
            </div>
          }
        </div>
      </div>
      <ProductList ref={selectProduct} selectedData={data} callback={addProduct} />
      {contextHolder}
    </>
  );
} 